import api from '../../api';

const state = {
  process: {
    next_meeting: '',
    next_session_id: '',
    meeting_status: '',
    session_id: '',
    session: 0,
    status: '',
    sub_tasks: [],
    is_pulse_open: false,
    has_other_engagements: false,
    duration: 4,
    extension_notice: {},
    display_congrats_modal: false,
    curr_engagement_uuid: null,
  },
  loading: false,
};

// getters
const getters = {
  nextSession: (state) => (state.process && state.process.next_session_id
    ? state.process.next_session_id
    : null),
  currentSession: (state) => (state.process && state.process.session_id
    ? state.process.session_id
    : null),
  needSurvey: (state) => state.process.sub_tasks.some((el) => el.description === 'doPulseSurvey'
    && el.status !== 'completed'
    && state.process.is_pulse_open),
  extendRequired: (state) => state.process && state.process.extension_notice
    && Object.keys(state.process.extension_notice).length > 0,
};

// mutations
const mutations = {
  removeProcess(state) {
    state.process = {
      next_meeting: '',
      next_session_id: '',
      session_id: '',
      session: 0,
      status: '',
      sub_tasks: [],
      is_pulse_open: false,
      duration: 4,
      extension_notice: {},
    };
  },

  setProcess(state, { process }) {
    state.process = process;
    if (state.process.session_id === 'on_boarding') {
      state.process.session = 0;
    } else {
      state.process.session = parseInt(state.process.session_id.replace('session_', ''), 10);
    }
  },

  loadingHandler(state, status) {
    state.loading = status;
  },

  updateNextMeeting(state, status) {
    state.process.next_meeting = status;
  },
};

// actions
const actions = {
  async fetchProcess({ commit, rootGetters }) {
    // empty data
    commit('removeProcess');
    commit('loadingHandler', true);

    try {
      const response = await api.getProcessStatus();
      commit('setProcess', {
        process: response.data,
      });

      setTimeout(() => {
        const userData = rootGetters['user/getAppcuesData'];
        userData.hasCoach = rootGetters['myCoach/hasCoach'];
        userData.currentSession = rootGetters['processStatus/currentSession'];
        // console.log('AppCues', userData);
        window.Appcues.identify(rootGetters['user/getUserUUID'], userData);
      }, 1000);

      return response.data;
    } catch (err) {
      return null;
    } finally {
      commit('loadingHandler', false);
    }
  },

  updateNextMeeting({ commit }, date) {
    commit('updateNextMeeting', date);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
